export enum PreferenceKeys {
  TotalJobsCount = 'total_jobs_count',
  CurrentMembership = 'membership',
  MembershipPackages = 'membership.packages',

  CurrentUser = 'UserInfo',
  UserPreference = 'userPreference',
  ApplyType = 'apply_type',

  SelectedLanguage = 'language.selected',
}
